<table>
  <tr *ngFor="let row of table">
    <td class="ext-ref-type" *ngIf="showTypeColumn">
      {{row.refType}}
    </td>
    <td class="ext-ref-name" *ngIf="!useNameAsLink">
      {{row.name}}
    </td>
    <td *ngIf="!useNameAsLink">
      <a href="{{row.url}}">{{row.linkLabel}}</a>
    </td>
    <td *ngIf="useNameAsLink">
      <a href="{{row.url}}">{{row.name}}</a>
    </td>
    <td>
      {{row.description}}
    </td>
  </tr>
</table>
